export const DEFAULT_MESSENGER_TEXTBOX_PLACEHOLDER = "Send a message...";
